import type { ReactNode } from 'react';

/**
 * The container every filter and search row sits in.
 *
 * `/reports` had one — `FilterBar` renders its own `surface` — and the eight
 * other screens with a search box or a status picker did not, so their controls
 * floated between the page heading and the table with nothing tying them to
 * either. The reading is genuinely ambiguous at a glance: a bare `<select>`
 * above a panel could be filtering the panel or be a leftover from the header.
 *
 * Extracted rather than copied because `FilterBar` uses it too. Two hand-written
 * `surface flex flex-col gap-4 p-4` strings is how the report screen's filter
 * card and the outlet screen's end up a padding step apart.
 *
 * The default row is `flex flex-wrap items-end gap-3` — items-end so a labelled
 * `Field` and a bare checkbox line up on their controls rather than on their
 * tops. Pass `layout="none"` when the caller needs its own grid inside, which is
 * what `FilterBar` does.
 */
export function FilterPanel({
  children,
  layout = 'row',
  className = '',
}: {
  children: ReactNode;
  layout?: 'row' | 'none';
  className?: string;
}) {
  return (
    <div className={`surface flex flex-col gap-4 p-4 ${className}`}>
      {layout === 'row' ? (
        <div className="flex flex-wrap items-end gap-3">{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
